import React from 'react';
export function SubscriberTagIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M9 1.017A7.375 7.375 0 008.5 1C4.364 1 2 4.358 2 8.5c0 3.13 1.547 5.814 3.94 6.937-.219.734-1.01 1.027-1.897 1.356C2.641 17.313 1 17.922 1 20.5v2h15v-2c0-2.578-1.641-3.187-3.043-3.707-.887-.329-1.678-.622-1.897-1.356 1.414-.664 2.533-1.873 3.212-3.397l-1.547-1.548C12.078 12.682 10.375 14 8.5 14 6.11 14 4 11.86 4 8.5c0-1.71.489-3.108 1.248-4.039C5.973 3.573 7.028 3 8.5 3c.172 0 .339.008.5.023V1.017z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13l-7-7V2l1-1h4l7 7-5 5zm-3-9a1 1 0 11-2 0 1 1 0 012 0z"
  }));
}